// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  item: {
    "overflow-kVQacm": "overflow-xb3r6kr",
    "paddingInline-kg3NbH": "paddingInline-x1awh872",
    $$css: "wino-gc:src/resources/selection-and-input/SearchListItem.res.js:11"
  },
  itemHovered: {
    "backgroundColor-kWkggS": "backgroundColor-x1srn7af",
    $$css: "wino-gc:src/resources/selection-and-input/SearchListItem.res.js:15"
  },
  itemCentered: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    $$css: "wino-gc:src/resources/selection-and-input/SearchListItem.res.js:18"
  }
};
function itemStyleFromParams(hovered, centered) {
  return [hovered ? styles.itemHovered : {}, centered ? styles.itemCentered : {}];
}
function SearchListItem(props) {
  let onPress = props.onPress;
  let name = props.name;
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let match = Hover.use(undefined, undefined, undefined);
  let newrecord = {
    ...Stylex.props(styles.item, itemStyleFromParams(match[1] && Stdlib_Option.isSome(onPress), Stdlib_Option.isNone(name)))
  };
  let tmp;
  if (name !== undefined && onPress !== undefined) {
    let newrecord$1 = {
      ...{
        className: "color-xbp64b2 font-x1qgc9lc letterSpacing-x1owzkzt lineHeight-x1vy86p0",
        "data-style-src": "wino-gc:src/resources/selection-and-input/SearchListItem.res.js:21"
      }
    };
    tmp = JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx("span", (newrecord$1.children = name, newrecord$1)),
      onPress: param => onPress(),
      ref: match[0]
    });
  } else {
    tmp = children;
  }
  newrecord.children = tmp;
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(SearchListItem);
export { make };
/* styles Not a pure module */